export enum AiAgentStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}

export interface AIAgentDetailsParams {
  agent_id: string;
}
